//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useUtils } from '@core/libs/i18n'
import { avatarText } from '@core/utils/filter'

export default {
  name: 'FacilityList',
  props: {
    facility: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  setup() {
    const { t } = useUtils()

    return {
      // methods
      avatarText,

      // i18n
      t,
    }
  },
}
